import { Module } from "vuex";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const createModuleOptions = <T>(options: Module<any, T>) => {
  return options;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const openModuleNamespaced = <T>(options: Module<any, T>) => {
  return {
    ...options,
    namespaced: true,
  };
};

export { createModuleOptions, openModuleNamespaced };
